module.exports = __webpack_public_path__ + "static/media/ico-use.77928e17.svg";